/**
 * Maps Firebase/Firestore error codes to user-friendly messages.
 * Centralizes error message logic so thunks and components stay consistent.
 */
export const getFirebaseErrorMessage = (error) => {
  const code = error?.code || '';
  const message = (error?.message || '').toLowerCase();

  switch (code) {
    case 'permission-denied':
      return 'You do not have permission to do this. Please try again.';
    case 'unavailable':
      return 'Service temporarily unavailable. Please check your connection and try again.';
    case 'deadline-exceeded':
      return 'Request timed out. Please try again.';
    case 'resource-exhausted':
      return 'Too many requests. Please wait a moment and try again.';
    case 'already-exists':
      return 'This has already been shared.';
    case 'not-found':
      return 'The requested content was no longer found.';
    case 'invalid-argument':
      return 'Invalid request. Please try again.';
    case 'failed-precondition':
      return 'This action cannot be performed right now. Please try again.';
    case 'auth/user-not-found':
      return 'Account not found. Please log in again.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection.';
    default:
      // Fallback: check message for common patterns
      if (message.includes('network') || message.includes('offline')) {
        return 'Network error. Please check your connection.';
      }
      if (message.includes('permission')) {
        return 'You do not have permission to do this.';
      }
      if (message.includes('quota') || message.includes('rate')) {
        return 'Too many requests. Please wait a moment.';
      }
      return error?.message || 'Something went wrong. Please try again.';
  }
};
